import { Box, styled } from '@mui/material';
import { Dispatch, JSX, SetStateAction } from 'react';
import {
  Assay, IBiomaterial, IPatient, ISubmitAssayData,
} from '@zero-dash/types';
import BiomaterialSelectionActionBar from './BiomaterialsSelectionActionBar';
import SubmitActionBar from './SubmitActionBar';

const Footer = styled(Box)({
  position: 'fixed',
  left: '50%',
  transform: 'translateX(-50%)',
  bottom: 60,
});

interface IProps {
  selectedBiomaterialIds: number[];
  onClose: () => void;
  handleOnResetChanges: () => void;
  selectedAssays: Assay[];
  setSelectedAssays: Dispatch<SetStateAction<Assay[]>>;
  showAssaySelectionBar: boolean;
  showSubmitActionBar: boolean;
  onApplyAssays: () => void;
  onSubmit: (name?: string) => Promise<void>;
  dataToSubmit: ISubmitAssayData[];
  biomaterials: IBiomaterial[];
  patientRecords: IPatient[];
  canSubmitAssays: boolean;
  resetDisabled: boolean;
  canSelectAssays: boolean;
}

export default function ActionBar({
  selectedBiomaterialIds,
  onClose,
  handleOnResetChanges,
  selectedAssays,
  setSelectedAssays,
  showAssaySelectionBar,
  showSubmitActionBar,
  onApplyAssays,
  onSubmit,
  dataToSubmit,
  biomaterials,
  patientRecords,
  canSubmitAssays,
  resetDisabled,
  canSelectAssays,
}: IProps): JSX.Element {
  return (
    <>
      {showAssaySelectionBar && (
        <Footer>
          <BiomaterialSelectionActionBar
            selectedBiomaterialIds={selectedBiomaterialIds}
            onClose={onClose}
            selectedAssays={selectedAssays}
            setSelectedAssays={setSelectedAssays}
            onApplyAssays={onApplyAssays}
            canSelectAssays={canSelectAssays}
          />
        </Footer>
      )}
      {showSubmitActionBar && (
        <SubmitActionBar
          dataToSubmit={dataToSubmit}
          biomaterials={biomaterials}
          patientRecords={patientRecords}
          onReset={handleOnResetChanges}
          onSubmit={onSubmit}
          canSubmitAssays={canSubmitAssays}
          resetDisabled={resetDisabled}
        />
      )}
    </>
  );
}
